import { useCallback } from 'react';

type Action = 'increment' | 'decrement';

const useChangeMebershipCount = (
  cartData: MemberShipDataTypes[],
  setCartData: React.Dispatch<React.SetStateAction<MemberShipDataTypes[]>>,
  handleClickModal: (index: number) => void
) => {
  const handleClickChangeCount = useCallback(
    (selectedIdx: number, action: Action) => {
      const updatedMembershipData = cartData.map((membership, index) => {
        if (index === selectedIdx) {
          let count;
          if (action === 'increment') {
            count = membership.count + 1;
          } else {
            count = Math.max(1, membership.count - 1);
            if (membership.count === 1 && count === 1) {
              handleClickModal(selectedIdx);
            }
          }
          return { ...membership, count };
        }
        return membership;
      });

      setCartData(updatedMembershipData);
    },
    [cartData, setCartData, handleClickModal]
  );

  return handleClickChangeCount;
};

export default useChangeMebershipCount;
